// extracted by mini-css-extract-plugin
module.exports = {"buttonsFooter":"AddNewMachinery_buttonsFooter__9OCm6"};